import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetServiceIpAssignmentRequest = (cellList, userName, userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}IpAssignment/ServiceIpAssignment`,
	params: { cellList, userName, userId }
});

export const AddCellRequest = (cellId, region, vendor, userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}IpAssignment/AddIpCellInformation`,
	params: { cellId, region, vendor, userId }
});
